import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'
import type { AthleticsTeamProfile } from '@/types/enrollments'

// GET /ajax/athletics/{enrollmentId}/team (DTA-799 round 9): the team's
// public profile for this family — nickname, positions legend, practice
// locations, usual practice times, coaches & staff, and reserved `blocks`.
//
// A 403 is the team keeping something private, not a dead session, so the
// auth redirect is suppressed and the caller shows the server's reason.
export const athleticsTeam = async (enrollmentId: number): Promise<AthleticsTeamProfile> => {
  const response = await new Request(undefined, 'json', { redirectOnForbidden: false }).get(
    '/ajax/athletics/' + enrollmentId + '/team'
  )
  const data = response.data ?? {}
  return Util.Obj.keysToCamel({
    schema_version: data.schema_version ?? 1,
    team: data.team ?? null,
    vocabulary: data.vocabulary ?? null,
    positions: data.positions ?? [],
    locations: data.locations ?? [],
    staff: data.staff ?? null,
    practice_defaults: data.practice_defaults ?? null,
    // reserved: future sport-specific blocks plug in here; nothing reads them today
    blocks: data.blocks ?? {}
  }) as AthleticsTeamProfile
}
